
<div class="redirect-cont">
  <h1>Redirection</h1>
  <p v-if="errorMessage">{{ errorMessage }}</p>
  <p v-else>Vous allez être redirigé vers la page de connexion.</p>
</div>
